import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createBlog_Admin, updateBlog_Admin, getBlog_Admin } from "../services/BlogAPI";
import Navbar from "../../components/base/Navbar";
import Footer from "../../components/base/Footer";

const BlogForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [author, setAuthor] = useState("");
    const [content, setContent] = useState("");

    useEffect(() => {
        if (id) {
            getBlog_Admin(id).then((response) => {
                const blog = response.data;
                if (blog) {
                    setTitle(blog.title);
                    setAuthor(blog.author);
                    setContent(blog.content);
                }
            });
        }
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (id) {
            await updateBlog_Admin(id, { title, author, content });
        } else {
            await createBlog_Admin({ title, author, content });
        }
        navigate("/admin/blogs");
    };

    return (
        <div className="bg-gray-200 pt-24 bg-center">

            <Navbar/>

            <form onSubmit={handleSubmit} className="p-4 bg-gray-100 rounded-md">
                <h2 className="text-xl font-bold">{id ? "Blog bearbeiten" : "Neuer Blog"}</h2>
                <div className="mb-4">
                    <label className="block mb-2 font-bold">Titel</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="w-full h-8 border rounded"
                        required
                    />

                    <label className="block mb-2 font-bold">Autor</label>
                    <input
                        type="text"
                        value={author}
                        onChange={(e) => setAuthor(e.target.value)}
                        className="w-full h-8 border rounded"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block mb-2 font-bold">Inhalt</label>
                    <textarea
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        className="w-full h-40 p-2 border field-sizing-fixed rounded"
                        required
                    />
                </div>
                <button type="submit" className="bg-blue-500 rounded-lg py-2 px-5 text-white hover:ring-2">
                    {id ? "Speichern" : "Erstellen"}
                </button>
            </form>

            <Footer/>
        </div>
    );
};

export default BlogForm;

